import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { applicationName, pathPrefix } from '../env'

/** Approved, unmodified TCG mark on a white clear-space plate in both modes. */
export default function TCGBrand({
  compact = false,
}: {
  compact?: boolean
}): React.JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
        py: 2,
      }}
    >
      <Box
        sx={{
          p: compact ? 2.5 : 3.5,
          bgcolor: '#FFFFFF',
          borderRadius: 1,
          lineHeight: 0,
        }}
      >
        <img
          src={pathPrefix + '/static/tcg-logo.png'}
          width={compact ? 72 : 112}
          alt='The Computer Guy — TCG'
          style={{ height: 'auto', display: 'block' }}
        />
      </Box>
      <Typography
        variant={compact ? 'h6' : 'h5'}
        component='div'
        sx={{ fontWeight: 700, textAlign: 'center' }}
      >
        {applicationName}
      </Typography>
    </Box>
  )
}
